let showMoreOffersHandler = () => {
    let offers = document.querySelectorAll('.ranking__wrap');
    let button = document.querySelector('.button__load-more');
    let offersLength = offers.length;
    let count = 10;
    let step = 10;

    if(offersLength > count) {
        for(let i = 0; i < offersLength; i++) {
            offers[i].style.display = 'none';
    
            for(let i = 0; i < count; i++) {
                offers[i].style.display = 'block'
            }        
        }
    
        button.addEventListener('click', ()=> {
            count = count + step;
    
            if(offersLength < count ) {
                button.style.display = 'none'
            }
    
            for(let i = 0; i < count; i++) {
                try {
                    offers[i].style.display = 'block';
                } catch(e) {
                    console.log(e)
                }
            }
    
        });
    } else {
        try{
            button.style.display = 'none'
        } catch(e) {}
    }

}

export default showMoreOffersHandler;